import { inject, injectable } from "inversify";
import { Either } from "@core/domain/types/either";
import { FallbackError } from "@core/domain/errors/fallback.error";
import { ValidationError } from "@core/domain/errors/validation.error";
import { FinancialEntityBudget } from "@project/domain/models/budget/financial-entity-budget.model";
import { CreateBudgetFromTemplate } from "@project/domain/models/budget-template/create-budget-from-template";
import { BudgetTemplateRepositoryAbstract } from "@project/domain/repositories/budget-template.repository.abstract";

@injectable()
export class CreateBudgetFromTemplateUseCase {
    constructor(
        @inject(BudgetTemplateRepositoryAbstract)
        private readonly budgetTemplateRepository: BudgetTemplateRepositoryAbstract,
    ) { }

    async execute(createBudgetFromTemplate: CreateBudgetFromTemplate): Promise<Either<ValidationError | FallbackError, FinancialEntityBudget>> {
        return await this.budgetTemplateRepository.createBudgetFromTemplate(createBudgetFromTemplate);
    }
}
